// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","icon-info-span":"IconInfoSpan_icon-info-span__i9OHt","icon-info-span__info-icon":"IconInfoSpan_icon-info-span__info-icon__+Ky1y"};